<dx-data-grid #masterDetailsGridContainer class="data-grid" [dataSource]="plannedStages" [remoteOperations]="false" [allowColumnReordering]="true" [rowAlternationEnabled]="true" [showBorders]="true">
	<dxo-paging [pageSize]="100"></dxo-paging>
	<dxo-pager [visible]="false" [showPageSizeSelector]="false" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
	<dxo-search-panel [visible]="false" [highlightCaseSensitive]="true"></dxo-search-panel>
	<dxo-group-panel [visible]="false"></dxo-group-panel>
	<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
	<dxo-export [enabled]="false"></dxo-export>
	<dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
	<dxi-column dataField="workOrderId" dataType="number" alignment="left"></dxi-column>
	<dxi-column dataField="operationNumber" dataType="text" alignment="left"></dxi-column>
	<dxi-column dataField="partNumber" dataType="text" alignment="left"></dxi-column>
	<dxi-column dataField="machineCellNumber" dataType="text" alignment="left"></dxi-column>
	<dxi-column dataField="estimatedStartDate" dataType="date" format="dd/MM/yyyy hh:mm" alignment="left"></dxi-column>
	<dxi-column dataField="quantityRequired" dataType="text" alignment="left"></dxi-column>
	<dxi-column dataField="quantityCompleted" dataType="text" alignment="left"></dxi-column>
</dx-data-grid>